export enum OrderTransactionStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CLOSED = 'closed',
  DELETED = 'deleted',
  VOIDED = 'voided',
}